import { Card, TextInput } from 'corso-admin-ui';
import { useFormContext } from 'react-hook-form';
import { useIsSuperUser } from '~/providers/AuthenticatedUserProvider';
import type { PlatformSettings } from './PlatformPage';

export function EmailSettingsCard() {
  const isSuperAdmin = useIsSuperUser();
  const {
    register,
    formState: { errors },
  } = useFormContext<PlatformSettings>();

  // ? only super admins can use this
  if (!isSuperAdmin) return null;
  return (
    <Card>
      <Card.Heading>Email</Card.Heading>

      <TextInput
        id="verified-email-domain"
        label="Verified email domain"
        details="Set only after the domain's DNS is verified with SendGrid. Merchants can then send customer emails from an address on this domain."
        {...register('verifiedEmailDomain')}
        error={errors.verifiedEmailDomain?.message}
      />
    </Card>
  );
}
